import axios from 'axios'

// export default axios.create({baseURL: `http://localhost:5000/`})
// export default axios.create({baseURL: `http://104.238.148.191:3000`})
export default axios.create({baseURL: `https://178.63.209.34:8443/`})



// WEBPACK FOOTER //
// ./src/plugins/axios.js